<script setup lang="ts">
import { userService } from "@/services/internal-api/auth.service";
import store from "@/state/store";
import { computed } from "vue";
import cache from "@/services/cache/cache.service";

const name = computed(() => {
  return (
    store.getters["auth/authFirstName"] +
    " " +
    store.getters["auth/authLastName"]
  );
});

const email = computed(() => {
  return store.getters["auth/authEmail"];
});

const teamOwner = computed(() => {
  return store.getters["auth/authTeamOwner"]?.user;
});

async function revertToTeamOwner() {
  await store.dispatch("auth/swapTeamOwnerToActive");
  userService.confirmLogin(
    {
      data: {
        user: store.getters["auth/authUser"],
        token: store.getters["auth/authToken"],
      },
    },
    "team_owner_impersonation"
  );

  cache.clear("content");
}
</script>

<template>
  <b-modal id="team-impersonation-modal" size="md" hide-header>
    <div v-if="teamOwner">
      <h5>You are currently viewing MyKCM as a Team Member</h5>
      <p>
        {{ name }}<br />
        {{ email }}<br />
      </p>
    </div>
    <div v-else>
      <h5>Great!</h5>
      <p>
        You're logged in with <b>{{ email }}</b>
      </p>
    </div>
    <template #modal-footer>
      <b-button
        @click="$bvModal.hide('team-impersonation-modal')"
        :variant="teamOwner ? 'secondary' : 'primary'"
        >{{ teamOwner ? "Close" : "Ok" }}</b-button
      >
      <b-button v-if="teamOwner" @click="revertToTeamOwner" variant="primary"
        >Switch back to {{ teamOwner.email }}</b-button
      >
    </template>
  </b-modal>
</template>
